import { useState } from "react";
import { cn } from "@/lib/utils";

function getInitials(name?: string) {
  if (!name) return "?";
  const words = name.trim().split(/\s+/);
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

export function CompanyAvatar({
  logoUrl,
  name,
  size = "md",
  // `soft` is the public board treatment: a quiet tile that reads as a
  // placeholder rather than a filled brand mark.
  tone = "solid",
}: {
  logoUrl?: string;
  name?: string;
  size?: "md" | "lg" | "xl" | "2xl";
  tone?: "solid" | "soft";
}) {
  const dims =
    size === "2xl"
      ? "h-16 w-16 text-xl"
      : size === "xl"
        ? "h-14 w-14 text-lg"
        : size === "lg"
          ? "h-12 w-12 text-base"
          : "h-10 w-10 text-sm";
  const [errored, setErrored] = useState(false);
  if (logoUrl && !errored) {
    return (
      <img
        src={logoUrl}
        alt={name ?? "Company logo"}
        className={cn(
          dims,
          "shrink-0 border border-border bg-card object-contain",
          tone === "soft" ? "rounded-xl p-1" : "rounded-lg"
        )}
        onError={() => setErrored(true)}
      />
    );
  }
  return (
    <div
      className={cn(
        dims,
        "flex shrink-0 items-center justify-center font-semibold",
        tone === "soft"
          ? "rounded-xl bg-muted text-foreground/70"
          : "rounded-lg bg-foreground text-background"
      )}
    >
      {getInitials(name)}
    </div>
  );
}
